import { useEffect } from "react";
import { useRouter } from "next/router";
import { useAppContext } from "@context/app";
import { requestNotificationPermission, shouldShowPrompt } from "@utils/oneSignal";
import { ISyncInput } from "@types";

export const useNotificationPrompt = () => {
    const { syncData } = useAppContext();
    const { pathname, query } = useRouter();

    const getScreenName = (path: string): ISyncInput["notification_prompt"][number]["screen_name"] | "" => {
        if (path === "/") return "home";
        if (path === "/checkout") return "checkout";
        if (path.startsWith("/product/")) return "product_details";
        return "";
    };

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const screenName = getScreenName(pathname);
        if (!screenName) return;

        let relevantPrompt = null;

        // Check if we have syncData with notification_prompt
        if (syncData?.notification_prompt) {
            relevantPrompt = syncData.notification_prompt.find(
                prompt => prompt.screen_name === screenName
            );
        }

        if (relevantPrompt && shouldShowPrompt(relevantPrompt, screenName)) {
            // Small delay to ensure page is loaded
            const timer = setTimeout(() => {
                requestNotificationPermission(relevantPrompt, screenName);
            }, 3000);

            return () => clearTimeout(timer);
        }

    }, [syncData, pathname, query.slug]);
};
